import { HTTP } from '../../http-common'

export default {
  state: {
    loadedAccounts: []
  },
  getters: {
    loadedAccounts (state) {
      return state.loadedAccounts
    }
  },
  mutations: {
    setLoadedAccounts (state, payload) {
      state.loadedAccounts = payload
    },
    createAccount (state, payload) {
      state.loadedAccounts.push(payload)
    },
    updateAccount (state, payload) {
      state.loadedAccounts = state.loadedAccounts.map(account => account.id === payload.id ? payload : account)
    },
    removeAccount (state, id) {
      state.loadedAccounts = state.loadedAccounts.filter(account => {
        return account.id !== id
      })
    },
    clearLoadedAccounts (state) {
      state.loadedAccounts = []
    }
  },
  actions: {
    loadAccounts ({ commit }) {
      commit('clearError')
      commit('setLoading', true)
      commit('setLoadedAccounts', [])

      return new Promise((resolve, reject) => {
        HTTP.get('account.json')
          .then(result => {
            console.log(result.data)
            commit('setLoadedAccounts', result.data.results)
            resolve(result.data)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    createAccount ({ commit, getters }, payload) {
      console.log('createAccount')
      commit('clearError')
      commit('setLoading', true)
      const newAccount = {
        name: payload.name,
        birth_day: payload.birth_day,
        country: {
          id: payload.country.id
        },
        state: {
          id: payload.state.id
        },
        city: {
          id: payload.city.id
        }
      }
      console.log('newAccount', newAccount)
      return new Promise((resolve, reject) => {
        HTTP.post('account.json/', newAccount)
          .then(result => {
            console.log(result)
            commit('createAccount', result.data)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    updateAccount ({ commit, getters }, payload) {
      console.log('updateAccount')
      commit('clearError')
      commit('setLoading', true)
      const account = {
        name: payload.name,
        birth_day: payload.birth_day,
        country: {
          id: payload.country.id
        },
        state: {
          id: payload.state.id
        },
        city: {
          id: payload.city.id
        }
      }
      return new Promise((resolve, reject) => {
        HTTP.patch(`account.json/${payload.id}/`, account)
          .then(result => {
            console.log(result)
            commit('updateAccount', result.data)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    removeAccount ({ commit }, payload) {
      console.log('removeAccount')
      commit('clearError')
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        HTTP.delete(`account.json/${payload}`)
          .then(result => {
            console.log('result', result)
            commit('removeAccount', payload)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    clearLoadedAccounts ({ commit }) {
      commit('clearLoadedAccounts')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/account/index.js